import React from 'react'
import cx from 'classnames'
import styleProvider, {
  SizeImage,
} from '@quotatisgroup/uikit-public.style-provider'

import './image.scss'

export type ImageProps = {
  className?: string
  classes?: string
  id?: string
  src: string
  alt?: string
  align?: 'right' | 'left' | 'center'
  size?: SizeImage
  hasBorderRadius?: boolean
  isBlock?: boolean
  width?: string
  height?: string
  md?: 'hide' | undefined
  sm?: 'hide' | undefined
  background?:
  | 'basic'
  | 'primary'
  | 'secondary'
  | 'danger'
  | 'success'
  | 'warning'
  | 'info'
  | 'grey'
  | 'white'
  onClick?: () => void
}

function ImageComponent({
  id,
  classes,
  className,
  src,
  alt,
  align,
  size,
  hasBorderRadius,
  isBlock,
  width,
  height,
  md,
  sm,
  background,
  onClick,
}: ImageProps) {
  return (
    <img
      id={id}
      onClick={onClick}
      src={src}
      className={cx(
        classes,
        `img-${size}`,
        `img-${background}`,
        `align-${align}`,
        {
          [`md-${md}`]: md,
          [`sm-${sm}`]: sm,
          [`border-radius`]: hasBorderRadius,
          block: isBlock,
        },
        className,
      )}
      width={width}
      height={height}
      alt={alt}
    />
  )
}

export const Image = styleProvider(ImageComponent)
